<template>
    <section class="flex h-full">
        <div class="m-auto w-1/2 h-3/4 ">
            <SignUp :inSystem="1"/>
        </div>
    </section>
</template>
<script>
import SignUp from '../Auth/SignUp.vue'
export default {
    name: 'CriarUsuarios',
    components: {
        SignUp
    }
}
</script>